<div class="offers-progress-dialog">
    <div class="offers-progress-dialog__header">
        <div *ngIf="logosVisible"
             class="offers-progress-dialog__header__logos"
             >
            <img *ngIf="partnerLogoUrl"
                 class="offers-progress-dialog__header__logo offers-progress-dialog__header__logo--partner"
                 [src]="partnerLogoUrl"
                 alt="">
            <div *ngIf="logosDividerVisible" class="offers-progress-dialog__header__divider"></div>
            <img class="offers-progress-dialog__header__logo offers-progress-dialog__header__logo--main"
                 [src]="logoUrl"
                 alt="">
        </div>
        <div class="offers-progress-dialog__header__title"
             [innerHTML]="getTranslationKey('title') | translate | safeHtml"
        ></div>
    </div>

    <div class="offers-progress-dialog__content">
        <div class="offers-progress-dialog__logos">
            <app-offers-progress-dialog-logo *ngFor="let state of insuranceCompaniesOffersState"
                                             class="offers-progress-dialog__logos__logo"
                                             [logo]="state.logo"
                                             [correctOffersAmount]="state.correctOffersAmount"
            ></app-offers-progress-dialog-logo>
        </div>

        <div class="offers-progress-dialog__counter">
            <span class="offers-progress-dialog__counter__prefix">
                {{ getTranslationKey('offersCounterPrefix') | translate }}
            </span>
            <div class="offers-progress-dialog__counter__spinner">
                {{ offersAmount }}
                <span class="loader"></span>
            </div>
            <div class="offers-progress-dialog__counter__suffix">
                {{ offersAmount | amountNounTranslation:'OFFER_SECTION' | async }}
            </div>
        </div>
    </div>

    <div *ngIf="animationVisible"
         class="offers-progress-dialog__animation">
        <ng-container *ngFor="let image of animationImages">
            <img *ngIf="image.animatableElement; else nonAnimatableElement"
                 #animatableElement
                 [src]="image.filepath"
                 [class]="'offers-progress-dialog__animation__image offers-progress-dialog__animation__image--' + image.cssSuffix"
            >
            <ng-template #nonAnimatableElement>
                <img [src]="image.filepath"
                     [class]="'offers-progress-dialog__animation__image offers-progress-dialog__animation__image--' + image.cssSuffix"
                >
            </ng-template>
        </ng-container>

        <div class="offers-progress-dialog__animation__line offers-progress-dialog__animation__line--static"
        ></div>
        <div #dynamicLine
             class="offers-progress-dialog__animation__line offers-progress-dialog__animation__line--dynamic"
        ></div>
    </div>
</div>
